import { z } from 'zod'

// String validators
export const nonEmptyString = z.string().trim().min(1)

// POI categories (shared between planner and AI modules)
export const poiCategorySchema = z.enum([
  'restaurant',
  'hotel',
  'attraction',
  'museum',
  'park',
  'beach',
  'shopping',
  'nightlife',
  'transport',
  'other'
])

export const latLngSchema = z.object({
  lat: z.number()
    .min(-90, 'La latitude doit être entre -90 et 90')
    .max(90, 'La latitude doit être entre -90 et 90'),
  lng: z.number()
    .min(-180, 'La longitude doit être entre -180 et 180')
    .max(180, 'La longitude doit être entre -180 et 180')
})

export const paginationSchema = z.object({
  page: z.number().int().min(1).default(1),
  limit: z.number().int().min(1).max(100).default(20)
})

export const idSchema = z.string().uuid()

export const timestampSchema = z.union([
  z.string().datetime(),
  z.date()
])
